$(document).ready(function () {
    /**
     * VideoJS
     * show button 2 minutes after video starts
     */
    if ($('#vitalRedsVSL').length) {
        videojs('vitalRedsVSL').ready(function () {
            this.on('timeupdate', function () {
                if (this.currentTime() >= (60 * 2) || this.currentTime() == this.duration()) {
                    $('.topSection .btn').removeClass('invisible');
                }
                // console.log(this.currentTime());
            })
        });
    };

    /**
     * Scroll to Cart
     */
    $('.btn:not(.cta)').on('click', function (event) {
        $('html, body').animate({
            scrollTop: $("#orderNow").offset().top
        }, 1000);
    });

    /**
     * Handle products
     */
    const
        body = $('body'),
        disclaimerBox = $('#disclaimerBox'),
        disclaimerTrigger = $('#disclaimerTrigger'),
        subscribeMode = $('#subscribeMode');

    //- Select Subscribe option if click on disclaimer box title
    disclaimerTrigger.on("click", function () {
        let checkbox = $('#subscribeCheckbox');
        let cartBtn = $('#cartCta');

        checkbox.toggleClass('checked');
        cartBtn.toggleClass('disabled');
    });

    // close disclaimer box
    $('#closeDisclaimer').on('click', function () {
        disclaimerBox.removeClass('subscribe-box__disclaimer--open');
    });

    // Subscribe Mode
    $('.subscribe-box__default').on('click', function () {
        let thisBtn = $(this);
        let cartBtn = $('#cartCta');
        let checkbox = $('#subscribeCheckbox');

        $('.subscribe-box__default').removeClass('active');
        thisBtn.addClass('active');

        disclaimerBox.addClass('subscribe-box__disclaimer--open');

        //- reset all UIs
        if (cartBtn.hasClass('disabled')) {
            cartBtn.removeClass('disabled');
        }

        if (checkbox.hasClass('checked')) {
            checkbox.removeClass('checked');
        }

        //- set 'data-subscribe' value + control UI
        if (thisBtn.hasClass('subscribe')) {
            subscribeMode.attr('data-subscribe', 'true');

            if (!cartBtn.hasClass('disabled')) {
                cartBtn.addClass('disabled');
            }

            if (!disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
                disclaimerBox.addClass('subscribe-box__disclaimer--open');
            }

        } else {
            subscribeMode.attr('data-subscribe', 'false');

            if (cartBtn.hasClass('disabled')) {
                cartBtn.removeClass('disabled');
            }

            if (disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
                disclaimerBox.removeClass('subscribe-box__disclaimer--open');
            }
        }

        $('.cart__product.active').trigger("click");
    });

    function activeProduct() {
        let thisProduct = $(this);
        let subscribeAttr = $('#subscribeMode').attr('data-subscribe');

        const retail = thisProduct.attr('data-retail');

        let price, link, subscribeSave,
            shipping = 'data-shipping',
            unit = thisProduct.attr('data-units'),
            badge = thisProduct.attr('data-stamp');

        if (subscribeAttr === 'true') {
            price = 'data-subscribe-amount';
            link = 'data-subscribe-tracker';

            $('.current__value').html(thisProduct.attr(price) + '<span>/month</span>');

        } else {
            price = 'data-amount';
            link = 'data-tracker';

            $('.current__value').html(thisProduct.attr(price));
        }

        $('.cart__product').removeClass('active');
        thisProduct.addClass('active');

        $('.retail__value').html(retail);
        $('.shipping__value').html((thisProduct.attr(shipping)));

        if (unit == '1' && subscribeAttr === 'true') {
            subscribeSave = 'data-subscribe-save';

            $('.saving__value').html(thisProduct.attr(subscribeSave));
        } else {
            $('.saving__value').html((retail - thisProduct.attr(price)).toFixed(2));
        }

        // Images to show according to the product unit
        $('.cart__image-item').removeClass('show').addClass('hide');
        $('.cart__image-item--' + unit + "").removeClass('hide').addClass('show');

        //- prints Best value per package
        if ($('#ribbon').length) {
            $('.ribbon__value').html(badge);
        }

        //- handle CTA by ID
        let param = $('#cartCta').attr('data-param');
        $('#cartCta').attr('href', thisProduct.attr(link) + param);
    }

    $('.cart__product').on('click', activeProduct);
    $('.cart__product.active').trigger("click");

    /**
     * Handle accordion on desktop to open 2 sections at a time
     */
    function accordionUI() {
        const accordion = $('#accordionKeyBenefits');
        let accordionTriggers = accordion.find('.accordion__title');
        let accordionContent = accordion.find('.accordion__body');
        // console.log(accordionTriggers.length);

        //- working but not scalable
        accordionTriggers.each(function (i) {
            let item = $(accordionTriggers[i]);
            let content = $(accordionContent[i]);

            // console.log(2 % accordionTriggers.length);

            //- TODO: recheck and improve loop to make it scalable
            if (i < 2 % accordionTriggers.length) {
                // console.log('condition #1: ' + i);

                item.attr('data-target', '.group1');
                content.addClass('group1');

                if (item.hasClass('collapsed')) {
                    item.removeClass('collapsed');
                    content.addClass('show');
                }

                if (item.attr('aria-expanded') == 'false') {
                    item.attr('aria-expanded', 'true');
                }

            } else {
                // console.log('condition #2: ' + i);

                item.attr('data-target', '.group2');
                content.addClass('group2');
            }
        })
    }

    if ($(window).outerWidth() > 1024) {
        accordionUI();
    }

    /**
     * consumptionLevels Slider
     */
    $('#consumptionLevelsSlide').slick({
        slidesToShow: 1,
        arrows: false,
        dots: true,
        speed: 700,
        adaptiveHeight: true,
        centerMode: false,
        infinite: false
    });

    /**
     * Reviews Slick
     */
    $('#reviewsList').slick({
        slidesToShow: 1,
        arrows: true,
        dots: true,
        speed: 700,
        adaptiveHeight: true,
        centerMode: false
    });

    //- Set current Year to footer Copyright
    let thisDate = new Date();
    $('#year').html(thisDate.getFullYear());
});
